import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../common.service';
import { ApiService } from '../api.service';
var AppScormComponent = (function () {
    function AppScormComponent(route, router, commonService, apiService) {
        this.route = route;
        this.router = router;
        this.commonService = commonService;
        this.apiService = apiService;
        this.language = 1;
        this.canClick = true;
    }
    AppScormComponent.prototype.ngOnInit = function () {
        localStorage.setItem('moduleId', '2');
        this.commonService.removeStorage('language');
        this.initPage();
    };
    AppScormComponent.prototype.initPage = function () {
        var _this = this;
        this.route.params.subscribe(function (params) {
            _this.courseId = params.courseId;
        });
        this.route.queryParams.subscribe(function (query) {
            _this.version = query.version;
            _this.courseName = query.name;
            _this.projectId = query.projectId;
        });
        var token = this.commonService.getStorage('transtalen-token');
        var host = window.location.origin.indexOf('localhost') >= 0 ? 'https://m-uat.transtalent.cn' : window.location.origin;
        var playerHost = host === 'https://m-uat.transtalent.cn' ? 'https://oss-uat.transtalent.cn' : 'https://oss-prod.transtalent.cn';
        var scormPlayer = document.getElementById('scormPlayer');
        if (scormPlayer instanceof HTMLIFrameElement) {
            scormPlayer.src = playerHost + "/scorm/scormPlayer.html?apiDomain=" + host + "/&token=" + token + "&courseId=" + this.courseId + "&language=" + this.language;
        }
        else {
            console.error('scormPlayer is not an iframe element');
        }
    };
    AppScormComponent.prototype.goToLearningMap = function () {
        var _this = this;
        if (this.canClick) {
            this.canClick = false;
            if (this.projectId) {
                this.router.navigate(['learning-project', this.projectId]).then();
            }
            else {
                this.router.navigate(['learning-map']).then();
            }
            setTimeout(function () {
                _this.canClick = true;
            }, 2000);
        }
    };
    AppScormComponent.prototype.changeLanguage = function () {
        this.language = Number(this.language) === 1 ? 2 : 1;
        this.initPage();
    };
    AppScormComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage();
    };
    return AppScormComponent;
}());
export { AppScormComponent };



// WEBPACK FOOTER //
// ./src/app/app-scorm/app-scorm.component.ts.pre-build-optimizer.js